
import { useNavigate, useParams } from "react-router-dom";
import { hostImg } from "../../../../callApi/AxiosCall";
import {
  createCircularDesignApi,
  createProductApi,
  deleteProductApi,
  editProductApi,
  getCircularDetailApi,
  getProductDetailApi,
  getProductTypeApi,
  getProductUnitApi,
  updateCircularDesignApi,
} from "../../../../callApi/productApi";
import CustomButton from "../../../../components/CustomButton";
import CustomInput from "../../../../components/CustomInput";
import CustomInputProduct from "../../../../components/CustomInputProduct";
import CustomHeader from "../../../../components/admin/CustomHeader";
import CustomLeftBar from "../../../../components/admin/CustomLeftBar";
import { province_th } from "../../../../data/province_th";
import { Icon } from "@iconify/react";
import { addYears, format } from "date-fns";
import Notiflix from "notiflix";
import React, { useEffect, useState } from "react";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";

export default function AdminProductsID() {
  const [nameProduct, setnameProduct] = useState("");
  const [old, setold] = useState("");
  const [no, setno] = useState("");
  const [amount, setamount] = useState("");
  const [product_types_id, setproduct_types_id] = useState("");
  const [price, setprice] = useState("");
  const [technic, settechnic] = useState("");
  const [note, setnote] = useState("");
  const [pattern, setpattern] = useState("");
  const [material, setmaterial] = useState("");
  const [attribute_old, setattribute_old] = useState("");
  const [width, setwidth] = useState("");
  const [length, setlength] = useState("");
  const [depth, setdepth] = useState("");
  const [product_units_id, setproduct_units_id] = useState("");
  const [product_img, setproduct_img] = useState(null);
  const [oldproduct_img, setoldproduct_img] = useState(null);
  const [type, settype] = useState([]);
  const [unit, setunit] = useState([]);
  const router = useNavigate();
  const [SelectType, setSelectType] = useState(1);

  //verify

  const [name, setname] = useState("");
  const params = useParams();
  const [CircularItem, setCircularItem] = useState(null);
  const [certification_doc, setcertification_doc] = useState("มผช.");
  const [certification_doc_check, setcertification_doc_check] = useState(false);
  const [economy_label, seteconomy_label] = useState("");
  const [economy_label_check, seteconomy_label_check] = useState(false);
  const [establishment, setestablishment] = useState("");
  const [fiber_type, setfiber_type] = useState("");
  const [fiber_type_check, setfiber_type_check] = useState(false);
  const [generalization, setgeneralization] = useState("");
  const [generalization_check, setgeneralization_check] = useState(false);
  const [ph_check, setph_check] = useState(false);
  const [phone, setphone] = useState("");
  const [processing_steps, setprocessing_steps] = useState(
    "อยู่ในภูมิภาคเดียวกับชุมชน"
  );
  const [production_steps, setproduction_steps] = useState(
    "อยู่ในภูมิภาคเดียวกับชุมชน"
  );
  const [province, setprovince] = useState("");
  const [size_change_check, setsize_change_check] = useState("");
  const [sweat_durability_check, setsweat_durability_check] = useState(false);
  const [wash_durability_check, setwash_durability_check] = useState(false);
  const [productItem, setproductItem] = useState(null);
  const [tag_check, settag_check] = useState(false);
  const [cer_date, setcer_date] = useState(format(new Date(), "yyyy-MM-dd"));
  const [exp_date, setexp_date] = useState(
    format(addYears(new Date(), 1), "yyyy-MM-dd")
  );
  useEffect(() => {
    CallType();
    CallUnit();
  }, []);

  useEffect(() => {
    if (params.id != null) {
      callCircular();
      callproduct();
    }
  }, [params]);

  const CallType = async () => {
    let res = await getProductTypeApi();
    if (res.status == 200) {
      settype(res.data.data);
    }
  };
  const CallUnit = async () => {
    let res = await getProductUnitApi();
    if (res.status == 200) {
      setunit(res.data.data);
      if (res.data.data.length > 0) {
        setproduct_units_id(res.data.data[0]);
      }
    }
  };
  const saveDataProduct = async () => {
    if (product_types_id.id == undefined) {
      Notiflix.Notify.warning("กรุณาเลือกประเภท");
    } else if (product_units_id.id == undefined) {
      Notiflix.Notify.warning("กรุณาเลือกหน่วย");
    } else {
      Notiflix.Loading.circle();
      let res = await editProductApi({
        id: params.id,
        amount,
        attribute_old,
        depth,
        length,
        material,
        name: nameProduct,
        no,
        note,
        old,
        pattern,
        price,
        product_img,
        product_types_id: product_types_id.id,
        product_units_id: product_units_id.id,
        technic,
        width,
      });
      Notiflix.Loading.remove();
      if (res.status == 200) {
        Notiflix.Notify.success("บันทึกสำเร็จ");
        callproduct();
        // router.push("/admin/products/verify/" + res.data.data.id);
      } else {
        Notiflix.Notify.failure("ผิดพลาด");
      }
    }
  };
  const EditProduct = () => {
    return (
      <div className="flex flex-col  ">
        <div className=" font-semibold text-[24px]">ผลิตภัณฑ์</div>
        <div className="border flex flex-col gap-5 rounded-lg p-5">
          <div className="grid grid-cols-2 gap-2">
            <CustomInputProduct
              value={nameProduct}
              onChange={(v) => setnameProduct(v)}
              title="ชื่อผลิตภัณฑ์"
              placeHolder="กรุณากรอกชื่อผลิตภัณฑ์"
              fontSize={14}
            />
            <CustomInputProduct
              value={no}
              onChange={(v) => setno(v)}
              title="รหัสผลิตภัณฑ์"
              placeHolder="กรุณากรอกรหัสผลิตภัณฑ์"
              fontSize={14}
            />
            <CustomInputProduct
              value={product_types_id}
              onChange={(v) => setproduct_types_id(v)}
              title="ประเภท"
              placeHolder="กรุณาเลือกประเภท"
              fontSize={14}
              type={"select"}
              data={type}
            />

            <CustomInputProduct
              value={product_units_id}
              onChange={(v) => setproduct_units_id(v)}
              title="หน่วยวัด"
              placeHolder="กรุณาเลือกประเภท"
              fontSize={14}
              type={"select"}
              data={unit}
            />
            <div className="flex flex-row items-center justify-center border rounded-md col-span-2 h-56">
              {product_img || oldproduct_img ? (
                <div className="flex flex-col items-center gap-2">
                  <Zoom>
                    <img
                      src={
                        product_img
                          ? URL.createObjectURL(product_img)
                          : hostImg + oldproduct_img
                      }
                      className="h-32 object-contain rounded-lg drop-shadow-lg"
                    />
                  </Zoom>
                  <div
                    onClick={() => {
                      document.getElementById("inputFile").click();
                    }}
                    className=" cursor-pointer  bg-white rounded-md drop-shadow-lg px-2 py-1 flex flex-row items-center text-black hover:bg-[#9E0400] hover:text-white"
                  >
                    <Icon icon={"uil:image-plus"} />
                    <p>เลือกภาพ</p>
                  </div>
                  {product_img ? (
                    <div
                      onClick={() => {
                        setproduct_img(null);
                      }}
                      className=" cursor-pointer  bg-white rounded-md drop-shadow-lg px-2 py-1 flex flex-row items-center text-black hover:bg-[#9E0400] hover:text-white"
                    >
                      <Icon icon={"uil:image-times"} />
                      <span>ลบ</span>
                    </div>
                  ) : null}
                </div>
              ) : (
                <div
                  onClick={() => {
                    document.getElementById("inputFile").click();
                  }}
                  className=" cursor-pointer flex flex-row gap-2 items-center hover:opacity-80 active:opacity-50"
                >
                  <Icon icon={"uil:image-v"} className="text-3xl" />
                  <p>เพิ่มภาพหลัก</p>
                </div>
              )}
              <input
                onChange={(e) => {
                  if (e.target.files.length > 0) {
                    console.log("e.target.files", e.target.files[0]);
                    setproduct_img(e.target.files[0]);
                  }
                }}
                type="file"
                className="hidden"
                name={"inputFile"}
                id={"inputFile"}
                accept=".png, .jpg, .jpeg"
                multiple={true}
                max={1}
                maxLength={1}
              />
            </div>
          </div>
          <div>ข้อมูลเพิ่มเติม</div>
          <div className="grid grid-cols-2 gap-2">
            <CustomInputProduct
              value={amount}
              onChange={(v) => setamount(v)}
              title="จำนวน"
              placeHolder="กรุณาใส่รายละเอียด"
              fontSize={14}
            />
            <CustomInputProduct
              value={price}
              onChange={(v) => setprice(v)}
              title="ราคา / หน่วย"
              placeHolder="กรุณาใส่รายละเอียด"
              fontSize={14}
            />
            <CustomInputProduct
              value={old}
              onChange={(v) => setold(v)}
              title="อายุ"
              placeHolder="กรุณาใส่รายละเอียด"
              fontSize={14}
            />
            <CustomInputProduct
              value={technic}
              onChange={(v) => settechnic(v)}
              title="เทคนิคการทอ"
              placeHolder="กรุณาใส่รายละเอียด"
              fontSize={14}
            />

            <CustomInputProduct
              value={pattern}
              onChange={(v) => setpattern(v)}
              title="ลาย"
              placeHolder="กรุณาใส่รายละเอียด"
              fontSize={14}
            />
            <CustomInputProduct
              value={material}
              onChange={(v) => setmaterial(v)}
              title="วัสดุ"
              placeHolder="กรุณาใส่รายละเอียด"
              fontSize={14}
            />
            <div className="grid grid-cols-3 gap-2 col-span-2">
              <CustomInputProduct
                value={width}
                onChange={(v) => setwidth(v)}
                title="กว้าง"
                placeHolder="กรุณาใส่รายละเอียด"
                fontSize={14}
              />
              <CustomInputProduct
                value={length}
                onChange={(v) => setlength(v)}
                title="ยาว"
                placeHolder="กรุณาใส่รายละเอียด"
                fontSize={14}
              />
              <CustomInputProduct
                value={depth}
                onChange={(v) => setdepth(v)}
                title="ลึก"
                placeHolder="กรุณาใส่รายละเอียด"
                fontSize={14}
              />
            </div>
            <CustomInputProduct
              value={attribute_old}
              onChange={(v) => setattribute_old(v)}
              title="คุณลักษณะ (เดิม)"
              placeHolder="กรุณาใส่รายละเอียด"
              fontSize={14}
            />
            <CustomInputProduct
              value={note}
              onChange={(v) => setnote(v)}
              title="หมายเหตุ"
              placeHolder="กรุณาใส่รายละเอียด"
              fontSize={14}
            />
          </div>
        </div>
        <div className=" flex flex-row gap-3 my-6 justify-center items-center">
          <CustomButton
            txt={"Save"}
            bgcolor="#2271B1"
            onClick={() => {
              saveDataProduct();
            }}
          />
          <CustomButton
            txt={"Cancel"}
            bgcolor="#9E0400"
            onClick={() => {
              router(-1);
            }}
          />
        </div>
      </div>
    );
  };

  const callCircular = async () => {
    let res = await getCircularDetailApi({ product_id: params.id });
    if (res?.status == 200) {
      const item = res.data.data;
      setCircularItem(item);
      setcertification_doc(item.certification_doc);
      setcertification_doc_check(item.certification_doc_check);
      seteconomy_label(item.economy_label ? { name: item.economy_label } : "");
      seteconomy_label_check(item.economy_label_check);
      setestablishment(item.establishment);
      setfiber_type(item.fiber_type);
      setfiber_type_check(item.fiber_type_check);
      setgeneralization(item.generalization);
      setgeneralization_check(item.generalization_check);
      setname(item.name);
      setph_check(item.ph_check);
      setphone(item.phone);
      setprocessing_steps(item.processing_steps);
      setproduction_steps(item.production_steps);
      setprovince(item.province ? { name: item.province } : "");
      setsize_change_check(item.size_change_check);
      setsweat_durability_check(item.sweat_durability_check);
      setwash_durability_check(item.wash_durability_check);
      settag_check(item.tag_check);
      setcer_date(item.cer_date ?? format(new Date(), "yyyy-MM-dd"));
      setexp_date(
        item.exp_date ?? format(addYears(new Date(), 1), "yyyy-MM-dd")
      );
    }
  };

  const callproduct = async () => {
    let res = await getProductDetailApi({ product_id: params.id });
    if (res?.status == 200) {
      setproductItem(res.data.data);
      const product = res.data.data;
      setnameProduct(product?.name ?? "");
      setno(product?.no ?? "");
      setamount(product?.amount ?? "");
      setold(product?.old ?? "");
      setproduct_types_id(product?.product_types ?? "");
      setprice(product?.price ?? "");
      settechnic(product?.technic ?? "");
      setnote(product?.note ?? "");
      setpattern(product?.pattern ?? "");
      setmaterial(product?.material ?? "");
      setattribute_old(product?.attribute_old ?? "");
      setwidth(product?.width ?? "");
      setlength(product?.length ?? "");
      setdepth(product?.depth ?? "");
      setproduct_units_id(product?.product_units ?? "");
      setoldproduct_img(product?.product_img ?? "");
    }
  };
  const saveData = async () => {
    if (province == "") {
      Notiflix.Notify.warning("กรุณากรอกข้อมูลให้ครบถ้วน");
    } else {
      Notiflix.Loading.circle();
      const data = {
        certification_doc,
        certification_doc_check: certification_doc != "" ? true : false,
        economy_label: economy_label?.name ?? "",
        economy_label_check: economy_label != "" ? true : false,
        establishment,
        fiber_type,
        fiber_type_check: fiber_type != "" ? true : false,
        generalization,
        generalization_check: generalization != "" ? true : false,
        name,
        ph_check,
        phone,
        processing_steps,
        production_steps,
        products_id: productItem?.id,
        province: province?.name ?? "",
        size_change_check,
        sweat_durability_check,
        wash_durability_check,
        tag_check,
        cer_date: cer_date,
        exp_date: exp_date,
      };
      let res;
      if (CircularItem) {
        res = await updateCircularDesignApi(data);
      } else {
        res = await createCircularDesignApi(data);
      }
      Notiflix.Loading.remove();
      if (res.status == 200) {
        Notiflix.Notify.success("บันทึกสำเร็จ");
        callproduct();
        callCircular();
      } else {
        Notiflix.Notify.failure("ผิดพลาด");
      }
    }
  };
  const EditVerify = () => {
    return (
      <div className="flex flex-col  ">
        <div className=" font-semibold text-[24px]">รายงานการตรวจสอบฉลาก</div>
        <div className="border flex flex-col gap-5 rounded-lg p-5">
          <div className="grid grid-cols-2 gap-2">
            <CustomInputProduct
              value={productItem?.name}
              title="ชื่อผลิตภัณฑ์"
              placeHolder="ชื่อผลิตภัณฑ์"
              disable
              fontSize={14}
            />
            <CustomInputProduct
              value={productItem?.no}
              title="รหัสผลิตภัณฑ์"
              placeHolder="รหัสผลิตภัณฑ์"
              disable
              fontSize={14}
            />
            <CustomInputProduct
              value={name}
              onChange={(v) => setname(v)}
              title="ชื่อผู้ยื่นขอ"
              placeHolder="ชื่อผู้ยื่นขอ"
              fontSize={14}
            />
            <CustomInputProduct
              value={phone}
              onChange={(v) => setphone(v)}
              title="เบอร์โทรศัพท์"
              placeHolder="กรุณากรอกหมายเลข"
              fontSize={14}
            />
            <CustomInputProduct
              value={establishment}
              onChange={(v) => setestablishment(v)}
              title="ชื่อสถานประกอบการ / กลุ่ม"
              placeHolder="กรุณาใส่รายละเอียด"
              fontSize={14}
            />
            <CustomInputProduct
              value={province}
              onChange={(v) => setprovince(v)}
              title="จังหวัด"
              placeHolder="กรุณาเลือกจังหวัด"
              type={"select"}
              data={province_th}
              fontSize={14}
            />
          </div>
          <div className=" font-semibold text-[20px]">
            1. หลักเกณฑ์วัตถุดิบหลัก
          </div>
          <div className="grid grid-cols-2 gap-2">
            <CustomInputProduct
              value={economy_label}
              onChange={(v) => seteconomy_label(v)}
              title="ฉลากเศรษฐกิจ"
              placeHolder="กรุณาเลือกชนิดของฉลาก"
              type={"select"}
              data={[
                { name: "ฉลากเศรษฐกิจหมุนเวียนสีเขียว (GREEN)" },
                { name: "ฉลากเศรษฐกิจหมุนเวียนสีทอง (GOLD)" },
                { name: "ฉลากเศรษฐกิจหมุนเวียนสีโรสโกลด์ (ROSE GOLD)" },
              ]}
              fontSize={14}
            />
            <CustomInputProduct
              value={fiber_type}
              onChange={(v) => setfiber_type(v)}
              title="ชนิดเส้นใย"
              placeHolder="กรุณาใส่รายละเอียด"
              fontSize={14}
            />
          </div>

          <div className=" font-semibold text-[20px]">
            2. การตรวจสอบผลิตภัณฑ์
          </div>

          <div className="grid grid-cols-2 gap-2">
            <CustomInputProduct
              value={generalization}
              onChange={(v) => setgeneralization(v)}
              title="ลักษณะทั่วไป"
              placeHolder="กรุณาระบุลักษณะ เช่น สี เนื้อผ้า ลวดลายสม่ำเสมอหรือไม่"
              fontSize={14}
            />
            <CustomInputProduct
              value={certification_doc}
              onChange={(v) => setcertification_doc(v)}
              title="เอกสารรับรอง"
              placeHolder="กรุณาใส่รายละเอียด"
              fontSize={14}
            />
            <div className="grid grid-cols-1 col-span-2 gap-2">
              <CustomInputProduct
                type="check"
                value={ph_check}
                onClick={() => setph_check(!ph_check)}
                title="ความเป็นกรด - ด่าง"
                subtitle="ระหว่าง 5.0 - 8.0"
                fontSize={14}
              />
              <CustomInputProduct
                type="check"
                value={size_change_check}
                onClick={() => setsize_change_check(!size_change_check)}
                title="การเปลี่ยนแปลงขนาดภายหลังการซักและทำให้แห้ง"
                subtitle="ไม่เกินร้อยละ 5"
                fontSize={14}
              />
              <CustomInputProduct
                type="check"
                value={wash_durability_check}
                onClick={() => setwash_durability_check(!wash_durability_check)}
                title="ความคงทนของสีต่อการซัก"
                subtitle="ไม่น้อยกว่าเกรย์สเกลระดับ 3 ทั้งการเปลี่ยนสีและการเปื้อนสี"
                fontSize={14}
              />
              <CustomInputProduct
                type="check"
                value={sweat_durability_check}
                onClick={() =>
                  setsweat_durability_check(!sweat_durability_check)
                }
                title="ความคงทนของสีต่อการเหงื่อ"
                subtitle="ไม่น้อยกว่าเกรย์สเกลระดับ 3 ทั้งการเปลี่ยนสีและการเปื้อนสี"
                fontSize={14}
              />
            </div>
          </div>
          <div className="grid grid-cols-2">
            <div className=" font-semibold text-[20px]">
              3. การตรวจสอบผลิตภัณฑ์
            </div>
            <div className="grid grid-cols-2"></div>
          </div>
          <div className="grid grid-cols-2 gap-2">
            <CustomInputProduct
              value={production_steps}
              onChange={(v) => setproduction_steps(v)}
              title="ขั้นตอนกระบวนการผลิต"
              placeHolder="กรุณาใส่รายละเอียด"
              fontSize={14}
            />
            <CustomInputProduct
              value={processing_steps}
              onChange={(v) => setprocessing_steps(v)}
              title="ขั้นตอนการแปรรูปผลิตภัณฑ์สำเร็จรูป"
              placeHolder="กรุณาใส่รายละเอียด"
              fontSize={14}
            />
          </div>

          <div className="grid grid-cols-2 gap-2">
            <CustomInputProduct
              value={cer_date}
              onChange={(v) => {
                setcer_date(v)
                setexp_date(format( addYears(new Date(v),1),'yyyy-MM-dd'))
              }
              }
              title="วันที่รับรองผลิตภัณฑ์ (ด/ว/ป)"
              placeHolder="กรุณาเลือกวัน"
              fontSize={14}
              type={"date"}
            />
            <CustomInputProduct
              value={exp_date}
              onChange={(v) => setexp_date(v)}
              title="วันที่ฉลากหมดอายุ (ด/ว/ป)"
              placeHolder="กรุณาเลือกวัน"
              fontSize={14}
              type={"date"}
            />
          </div>
          {CircularItem ? (
            <div className="flex flex-col justify-center items-center">
              <CustomInputProduct
                type="check"
                value={tag_check}
                onClick={() => settag_check(!tag_check)}
                title="ผ่านการรับรองฉลาก Circular Design Tag"
                subtitle=""
                fontSize={14}
              />
            </div>
          ) : null}
        </div>
        <div className=" flex flex-row gap-3 my-6 justify-center items-center">
          <CustomButton
            txt={"Save"}
            bgcolor="#2271B1"
            onClick={() => {
              saveData();
            }}
          />
          <CustomButton
            txt={"Cancel"}
            bgcolor="#9E0400"
            onClick={() => {
              router(-1);
            }}
          />
        </div>
      </div>
    );
  };

  const deleteProduct = async () => {
    const res = await deleteProductApi({ product_id: params.id });
    if (res?.status == 200) {
      Notiflix.Notify.success("สำเร็จ");
      router("/admin/home");
      router("/admin/products");
    }
  };
  return (
    <div className="flex flex-col h-screen">
      <CustomHeader />
      <div className="flex flex-row flex-[1] overflow-hidden">
        <CustomLeftBar page="Products" subPage="Add New Products" />
        <div className="p-8 flex flex-col  flex-[1] overflow-y-scroll relative">
          <div className="grid grid-cols-2 w-72 self-center cursor-pointer border rounded-xl drop-shadow-lg bg-white">
            <div
              className={
                "text-center hover:opacity-80 active:opacity-50 rounded-l-xl py-1 " +
                (SelectType == 1 ? "bg-admin-primary text-white " : "")
              }
              onClick={() => {
                setSelectType(1);
              }}
            >
              ผลิตภัณฑ์
            </div>
            <div
              className={
                "text-center hover:opacity-80 active:opacity-50 rounded-r-xl py-1 " +
                (SelectType == 2 ? "bg-admin-primary text-white " : "")
              }
              onClick={() => {
                setSelectType(2);
              }}
            >
              ตรวจสอบฉลาก
            </div>
          </div>
          <div className="absolute right-8">
            <CustomButton
              txt={"ลบ"}
              bgcolor="#9E0400"
              onClick={() => {
                Notiflix.Confirm.show(
                  "ยืนยันการทำรายการ",
                  "คุณต้องการลบผลิตภัณฑ์นี้ใช่หรือไม่ ? ",
                  "ยืนยัน",
                  "ยกเลิก",
                  () => {
                    deleteProduct();
                  },
                  () => {},
                  {
                    titleColor: "#9E0400",
                    okButtonBackground: "#9E0400",
                  }
                );
              }}
            />
          </div>
          {SelectType == 1 ? EditProduct() : null}
          {SelectType == 2 ? EditVerify() : null}
        </div>
      </div>
    </div>
  );
}
